import React, { Component, useEffect } from 'react';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import Welcome from '../../Containers/Welcome';
import Dashboard from '../../Containers/Dashboard';
import { useSelector } from 'react-redux';
import AccountTable from '../../Containers/AccountTable';
const Account = ({}) => {
  const user = useSelector((state) => state.app.user);
  useEffect(() => {
    if (user && user.personal !== 0) {
      window.location.href = '/';
    }
  }, [user]);
  return (
    <>
      <Header />
      {user?.personal === 0 && <AccountTable />}
      <Footer />
    </>
  );
};

export default Account;
